import { forwardRef, Fragment, useImperativeHandle, useRef, useState } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { MessageDialog, useMessageDialogText } from '../../MessageDialog';
import bundle from '../NovaComponents-KeyboardShortcuts-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const FileImporter = /*#__PURE__*/forwardRef((props, ref) => {
  const localize = useTextLocalizer();
  const inputRef = useRef(null);
  const [messageDialogProps, setMessageDialogProps] = useState();
  const {
    CANCEL,
    CLOSE
  } = useMessageDialogText();
  useImperativeHandle(ref, () => ({
    open: () => {
      inputRef.current?.click();
    }
  }));
  const showError = (text, detailText) => {
    setMessageDialogProps({
      type: 'error',
      isOpen: true,
      title: localize('importShortcuts.dialog.title'),
      text,
      detailText,
      dismissAction: {
        text: CLOSE,
        onPress: () => setMessageDialogProps(prev => ({
          ...prev,
          isOpen: false
        }))
      }
    });
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("input", {
      type: "file",
      hidden: true
      // always clear the value so that selecting the same file later will trigger change event again
      ,
      value: "",
      capture: false,
      accept: props.fileType,
      ref: inputRef,
      onChange: event => {
        const file = event.target.files?.[0];
        if (file && (file.type === '' || file.type === 'text/plain' || props.fileType && file.name.endsWith(props.fileType))) {
          readJSON(file).then(data => setMessageDialogProps({
            type: 'warning',
            isOpen: true,
            title: localize('importShortcuts.dialog.title'),
            text: localize('confirmReplace.msg'),
            firstAction: {
              text: localize('replaceAll.button.label'),
              onPress: () => {
                setMessageDialogProps(prev => ({
                  ...prev,
                  isOpen: false
                }));
                props.onImport(data);
              }
            },
            dismissAction: {
              text: CANCEL,
              isDefault: true,
              onPress: () => setMessageDialogProps(prev => ({
                ...prev,
                isOpen: false
              }))
            }
          })).catch(reason => showError(localize('fileError.msg'), reason?.message));
        } else {
          showError(localize('invalidFile.msg'));
        }
      }
    }), messageDialogProps ? /*#__PURE__*/_jsx(MessageDialog, {
      ...messageDialogProps
    }) : null]
  });
});
const readJSON = file => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = e => {
      const result = e.target?.result?.toString();
      if (result && result.length) {
        try {
          resolve(JSON.parse(result));
        } catch (ex) {
          reject(ex);
        }
      } else {
        reject();
      }
    };
    reader.onerror = reject;
    reader.readAsText(file);
  });
};
//# sourceMappingURL=FileImporter.js.map